(() => {
  const initCoastdDesktopMenu = () => {
    const nav = document.querySelector('.coastd-desktop-nav');
    const menu = document.querySelector('.coastd-desktop-menu');
    const trigger = document.querySelector('.coastd-desktop-nav__trigger');
    const scrim = document.querySelector('.coastd-desktop-menu__scrim');

    if (!nav || !menu || !trigger || !scrim || nav.dataset.coastdReady === 'true') return;
    nav.dataset.coastdReady = 'true';

    const desktopQuery = window.matchMedia('(min-width: 990px)');

    const openMenu = () => {
      if (!desktopQuery.matches) return;
      menu.hidden = false;
      scrim.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('coastd-desktop-menu-open');
    };

    const closeMenu = () => {
      menu.hidden = true;
      scrim.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('coastd-desktop-menu-open');
    };

    const toggleMenu = () => {
      if (menu.hidden) openMenu();
      else closeMenu();
    };

    trigger.addEventListener('click', toggleMenu);
    scrim.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });

    document.addEventListener('click', (event) => {
      if (menu.hidden) return;
      if (!menu.contains(event.target) && !trigger.contains(event.target)) closeMenu();
    });

    desktopQuery.addEventListener('change', (event) => {
      if (!event.matches) closeMenu();
    });

    document.addEventListener('shopify:section:load', closeMenu);
    document.addEventListener('shopify:section:unload', closeMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCoastdDesktopMenu);
  } else {
    initCoastdDesktopMenu();
  }

  document.addEventListener('shopify:section:load', initCoastdDesktopMenu);
})();
